import { useEffect, useRef, useState } from 'react';

export const useObserveElementWidth = <T extends HTMLElement>() => {
  const [width, setWidth] = useState(0);
  const ref = useRef<T>(null);

  useEffect(() => {
    const element = ref.current;
    const observer = new ResizeObserver(entries => {
      setWidth(entries[0].contentRect.width);
    });

    if (element) {
      observer.observe(element);
      return () => {
        observer.unobserve(element);
      };
    }
  }, []);

  return { width, ref };
};
